import React, { ReactNode } from 'react';
import SocialProof from '../SocialProof';
import styles from './LoginView.module.scss';

const AccessibilityBanner = () => (
  <div className={styles.accessibilityBanner}>
    <div>
      <svg width="20" height="20" viewBox="0 0 20 20">
        <circle fill="none" stroke="#FFBD27" strokeWidth="1.6" cx="10" cy="10" r="9" />
        <circle fill="#FFBD27" cx="10" cy="6.4" r="1.2" />
        <path stroke="#FFBD27" strokeWidth="1.6" strokeLinecap="round" d="M10 14.43v-4.66" />
      </svg>
      Web app not optimized for mobile
    </div>
  </div>
);

export default function LoginView({
  children,
  includeAccessibilityBanner,
}: {
  children: ReactNode;
  includeAccessibilityBanner?: boolean;
}) {
  return (
    <div className={styles.container}>
      {includeAccessibilityBanner && <AccessibilityBanner />}
      <div className={styles.scrollingContainer}>
        {children}
        <SocialProof />
      </div>
    </div>
  );
}
